






















import { FinanceType, LoadingStatusType, TransactionType } from "@/enums/enums";
import { ChangeNameByLanguageType, NewObject } from "@/helper/shareHelper";
import { FilterAccountOfTransaction } from "@/helper/accountHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { SuggestionDescription } from "@/helper/transactionItemHelper";

const StoreAccount = namespace("Account");

@Component
export default class DropdownAccountId extends Vue {
  @Prop({}) readonly index!: number;
  @Prop({}) readonly transactionItem!: any;
  @Prop({}) readonly transactionCreate!: any;

  private accountList: any = [];
  private selectAccount: any = "";
  private financeType = FinanceType;

  @StoreAccount.Getter
  private getAccountList!: any;
  @StoreAccount.Getter
  private getAccountListLoadingStatus!: LoadingStatusType;

  @StoreAccount.Action
  private DoGetAllMainAccount!: () => void;

  get isAccountListLoading() {
    return this.getAccountListLoadingStatus == LoadingStatusType.Loading;
  }

  @Watch("transactionItem.account.id")
  transactionAccountIdChanged() {
    if (this.getAccountListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchAccount();
    }
  }

  @Watch("transactionItem.account.code")
  transactionAccountCodeChanged() {
    if (this.getAccountListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchAccount();
    }
  }

  @Watch("getAccountListLoadingStatus", { immediate: true })
  getAccountListLoadingStatusChanged() {
    if (this.getAccountListLoadingStatus === LoadingStatusType.Success) {
      this.accountList = [];
      this.accountList = FilterAccountOfTransaction(this.getAccountList, this.transactionCreate.financeType);
      for (const account of this.accountList) {
        account.nameLocale = ChangeNameByLanguageType(account.name);
      }
      if (typeof this.transactionItem !== "undefined") {
        this.DoMatchAccount();
      }
    } else if (this.getAccountListLoadingStatus === LoadingStatusType.None) {
      this.DoGetAllMainAccount();
    }
  }

  @Watch("selectAccount")
  selectAccountChanged(newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      this.SelectAccount(this.selectAccount);
    }
  }

  public SetAccountIsNotAuto() {
    this.transactionItem.account.isNotAuto = this.transactionItem.productTemplate.id !== 0;
    if (this.transactionItem.account.isNotAuto) {
      this.transactionItem.itemWht.isNotAuto = false;
    }
  }

  public DoMatchAccount() {
    if (this.transactionItem.account.id > 0) {
      this.SelectAccount(this.getAccountList.find((x: any) => x.id === this.transactionItem.account.id));
    } else if (this.transactionItem.account.code && this.transactionItem.account.code.length !== 0) {
      this.SelectAccount(this.getAccountList.find((x: any) => x.code === this.transactionItem.account.code));
    } else {
      this.selectAccount = "";
    }
  }

  public SelectAccount(item: any) {
    if (item) {
      this.selectAccount = item;
      this.OnChangeAccount(item);
    } else {
      this.SetDefaultAccount();
    }
  }

  public OnChangeAccount(item: any) {
    const newDescription = item.name.locale;
    const oldDescription = this.transactionItem.account.name;

    if (!this.transactionItem.account.isNotAuto) {
      this.transactionItem.description.text = SuggestionDescription(
        newDescription,
        oldDescription,
        this.transactionItem.description.text
      );
      this.SetVatTypeIdBySuggestAccountVatType(item);
    } else if (this.transactionItem.vatTypeId.isSuggestion) {
      this.SetVatTypeIdBySuggestAccountVatType(item);
      this.transactionItem.vatTypeId.isSuggestion = false;
      if (this.transactionItem.description.text == null || this.transactionItem.description.text === "") {
        this.transactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          this.transactionItem.description.text
        );
      }
    } else if (this.transactionItem.description.text == null || this.transactionItem.description.text === "") {
      this.transactionItem.description.text = SuggestionDescription(
        newDescription,
        oldDescription,
        this.transactionItem.description.text
      );
    }
    this.transactionItem.account.code = item.code;
    this.transactionItem.account.id = item.id;
    this.transactionItem.account.name = item.name.locale;
    this.transactionItem.account.taxIncomeTypeId = item.taxIncomeTypeId;

    this.$emit("change");
  }

  public SetDefaultAccount() {
    this.transactionItem.account.code = "";
    this.transactionItem.account.id = 0;
    this.$emit("change");
  }

  public SetVatTypeIdBySuggestAccountVatType(item: any) {
    if (
      this.transactionCreate.financeType == FinanceType.OutFlow &&
      this.transactionCreate.transactionType == TransactionType.Invoice &&
      this.transactionItem.productTemplate.id == 0 &&
      item.suggestAccountVatType !== 0
    ) {
      this.transactionItem.vatTypeId.value = item.suggestAccountVatType;
    }
  }
}
